import HotelCardAdjacentTours from './HotelCardAdjacentTours';

export default HotelCardAdjacentTours;
